<div class="placeholder-panel">
  <h2 class="placeholder-title">Users</h2>
  <p class="placeholder-text">Coming soon — user management within scoped customers.</p>
</div>
